import { Button, Card, Row, Input, Typography, message } from "antd";
import { useEffect, useState } from "react";
import HTTPClient from "../../../utils/HTTPClient";
import { useTranslation } from "react-i18next";
const CustomCommands = ({ appName, app, getData, appBundleTechnology }) => {
    const [startCommand, setStartCommand] = useState("");
    const [buildCommand, setBuildCommand] = useState("");
    const { t } = useTranslation();
    const setCommands = () => {
        HTTPClient.post("/appcustomizations/custom_commands", {
            app_name: appName,
            technology: appBundleTechnology,
            start_command: startCommand,
            build_command: buildCommand,
        })
            .then((res) => {
                message.success(t("dettaglio_app.custom_commands.success"));
            })
            .catch((e) => {
                message.error(t("dettaglio_app.custom_commands.error"));
            });
    };

    useEffect(() => {
        HTTPClient.get("/appcustomizations/custom_commands/" + appName + "/" + appBundleTechnology)
            .then((res) => {
                if (res.data) {
                    setStartCommand(res.data.start_command);
                    setBuildCommand(res.data.build_command);
                }
            })
            .catch((e) => {});
    }, []);

    return (
        <Card title="Comandi Custom" style={{ width: "100%", marginTop: "15px" }}>
            <Row style={{ width: "100%", marginTop: "10px" }}>
                <Typography.Text>
                    {t("dettaglio_app.custom_commands.info.1")}
                    <br />
                    <i>pip install -r requirements.txt</i> | <i>npm install</i>
                </Typography.Text>
            </Row>
            <Row style={{ width: "100%", marginTop: "10px" }}>
                <Typography.Text>{t("dettaglio_app.custom_commands.info.2")}</Typography.Text>
                <Input value={startCommand} onChange={(e) => setStartCommand(e.target.value)} />
            </Row>
            <Row style={{ width: "100%", marginTop: "10px" }}>
                <Typography.Text> {t("dettaglio_app.custom_commands.info.3")}</Typography.Text>
                <Input value={buildCommand} onChange={(e) => setBuildCommand(e.target.value)} />
            </Row>
            <Row style={{ width: "100%", marginTop: "10px" }}>
                <Button
                    type="primary"
                    onClick={() => setCommands()}
                    style={{ "margin-right": "10px", "margin-bottom": "5px" }}>
                    {t("dettaglio_app.custom_commands.save")}
                </Button>
            </Row>
        </Card>
    );
};

export { CustomCommands };
